import { v5 as uuidv5 } from 'uuid'

/**
 * Deterministic UUIDv5 ids for the two system custom-field tabs that every workspace gets.
 *
 * The same namespace UUID and seed strings are duplicated in:
 *   - Backend: moly-platform/src/Moly/Domain/Constants/SystemTabIds.cs
 *   - Migration SQL: AddCustomFieldTabsAndGroups (uses uuid_generate_v5)
 * All three must produce byte-identical UUIDs for any given workspaceId — verified by
 * SystemTabIdsTests.cs and systemTabIds.test.ts pinning the same expected values.
 */

export const SYSTEM_TAB_NAMESPACE = '6f7e8d9c-1a2b-4c3d-9e5f-0a1b2c3d4e5f'
export const SYSTEM_TAB_OVERVIEW_SEED = 'customFieldTab:overview'
export const SYSTEM_TAB_PROPERTIES_SEED = 'customFieldTab:properties'

export const systemTabOverviewId = (envId: string): string =>
  uuidv5(`${envId}:${SYSTEM_TAB_OVERVIEW_SEED}`, SYSTEM_TAB_NAMESPACE)

export const systemTabPropertiesId = (envId: string): string =>
  uuidv5(`${envId}:${SYSTEM_TAB_PROPERTIES_SEED}`, SYSTEM_TAB_NAMESPACE)

export const isSystemTabId = (envId: string, tabId: string): boolean =>
  tabId === systemTabOverviewId(envId) || tabId === systemTabPropertiesId(envId)
